"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CharCodes_1 = require("../enum/CharCodes");

exports.binaryOps = {
  '=': 0,
  '+=': 0,
  '-=': 0,
  '*=': 0,
  '/=': 0,
  '%=': 0,
  '++': 0,
  '--': 0,
  '||': 1,
  '&&': 2,
  '^': 4,
  '&': 5,
  '==': 6,
  '!=': 6,
  '===': 6,
  '!==': 6,
  '<': 7,
  '>': 7,
  '<=': 7,
  '>=': 7,
  'gt': 7,
  'lt': 7,
  'gte': 7,
  'lte': 7,
  '+': 9,
  '-': 9,
  '*': 10,
  '/': 10,
  '%': 10
};

function isDecimalDigit(ch) {
  return ch >= CharCodes_1.default._0 && ch <= CharCodes_1.default._9;
}

exports.isDecimalDigit = isDecimalDigit;

function isLetter(ch) {
  return ch >= CharCodes_1.default.a && ch <= CharCodes_1.default.z || ch >= CharCodes_1.default.A && ch <= CharCodes_1.default.Z;
}

exports.isLetter = isLetter;

function isWhitespace(ch) {
  return ch === CharCodes_1.default.Space || ch === CharCodes_1.default.Tab || ch === CharCodes_1.default.CarriageReturn || ch === CharCodes_1.default.LineFeed;
}

exports.isWhitespace = isWhitespace;

function isIdentifierStart(ch) {
  return (isLetter(ch) || ch === CharCodes_1.default.$ || ch === CharCodes_1.default.Underscore || ch >= 128) && !exports.binaryOps[String.fromCharCode(ch)];
}

exports.isIdentifierStart = isIdentifierStart;

function isIdentifierPart(ch) {
  return (isLetter(ch) || isDecimalDigit(ch) || ch === CharCodes_1.default.$ || ch === CharCodes_1.default.Underscore || ch >= 128) && !exports.binaryOps[String.fromCharCode(ch)];
}

exports.isIdentifierPart = isIdentifierPart;
exports.unaryOps = {
  '-': true,
  '!': true,
  '~': true,
  '+': true,
  '?': true,
  '--': true,
  '++': true
};

function getMaxKeyLen(obj) {
  var maxLen = 0;
  var len;

  for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    len = key.length;

    if (len > maxLen) {
      maxLen = len;
    }
  }

  return maxLen;
}

exports.maxUnopLen = getMaxKeyLen(exports.unaryOps);
exports.maxBinopLen = getMaxKeyLen(exports.binaryOps);
exports.literals = {
  true: true,
  false: false,
  null: null
};